module.exports = __webpack_public_path__ + "static/media/title6.bf7ad39f.jpg";